angular.module('sfx.analyticsSelector', ['signalboost', 'signalview.analytics', 'sfx.ui']);
